import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import TripleRoom from "@/components/hotel/TripleRoom";
import Footer from "@/components/hotel/Footer";
import SEO, { BASE_URL } from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const TripleRoomPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Dreibettzimmer"
        description="Komfortables Dreibettzimmer im ESOS Hotel Quelle Bad Ragaz – perfekt für kleine Gruppen oder Familien."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Zimmer", path: "/rooms" },
          { name: "Dreibettzimmer", path: "/rooms/triple" },
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "HotelRoom",
          name: "Dreibettzimmer",
          description: "Komfortables Dreibettzimmer mit Doppelbett und Einzelbett, eigenem Bad.",
          url: `${BASE_URL}/rooms/triple`,
          bed: [
            { "@type": "BedDetails", typeOfBed: "Doppelbett", numberOfBeds: 1 },
            { "@type": "BedDetails", typeOfBed: "Einzelbett", numberOfBeds: 1 },
          ],
          occupancy: { "@type": "QuantitativeValue", minValue: 1, maxValue: 3 },
          amenityFeature: [
            { "@type": "LocationFeatureSpecification", name: "WLAN", value: true },
            { "@type": "LocationFeatureSpecification", name: "TV", value: true },
            { "@type": "LocationFeatureSpecification", name: "Eigenes Bad", value: true },
            { "@type": "LocationFeatureSpecification", name: "Parkplatz", value: true },
          ],
        }}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.tripleRoom.title} subtitle={t.subpageHeroes.tripleRoom.subtitle} />
      <TripleRoom />
      <Footer />
    </main>
  );
};

export default TripleRoomPage;
